import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNextStep = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 11,
			r: 11
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 11.465l-3.633 3.719a.636.636 0 01-.453.192.626.626 0 01-.452-.192l-.605-.62a.655.655 0 01-.188-.463.666.666 0 01.188-.463l2.575-2.635-2.575-2.635a.656.656 0 01-.188-.464.666.666 0 01.188-.463l.601-.623a.636.636 0 01.453-.193.626.626 0 01.453.193l3.633 3.717a.654.654 0 01.191.464.666.666 0 01-.189.466H12z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.14 11.465l-3.631 3.719a.636.636 0 01-.453.192.625.625 0 01-.452-.192L12 14.562a.655.655 0 01-.188-.464.667.667 0 01.188-.463L14.574 11l-2.571-2.638a.657.657 0 01-.188-.463.666.666 0 01.188-.464l.603-.617a.636.636 0 01.453-.193.626.626 0 01.452.193l3.632 3.717a.658.658 0 01.187.466.668.668 0 01-.19.464z",
			fill: "#fff"
		})
	]
});
export default SvgIconNextStep;
